module.exports = __webpack_public_path__ + "img/qr-1.bb05f5dd.png";